export const BILLING_SUBSCRIPTION_PERMISSION = {
  JOB_INVITE: 'job_invite',
  JOB_RECOMMENDATION: 'job_recommendations',
  CANDIDATES_ADVANCED_SEARCH_FILTER: 'candidates_advanced_search_filter',
}

export const BILLING_SUBSCRIPTION_FREE_MONTH_POSTED_JOBS_COUNT = 1
